(() => {
  const roots = document.querySelectorAll('[data-sky-help-center]');

  roots.forEach((root) => {
    const searchInput = root.querySelector('[data-sky-help-search]');
    const filterButtons = root.querySelectorAll('[data-sky-help-filter]');
    const items = root.querySelectorAll('[data-sky-help-item]');
    const emptyState = root.querySelector('[data-sky-help-empty]');
    let activeFilter = 'all';

    const normalize = (value) => (value || '').trim().toLowerCase();

    const updateResults = () => {
      const query = normalize(searchInput ? searchInput.value : '');
      let visibleCount = 0;

      items.forEach((item) => {
        const matchesFilter = activeFilter === 'all' || item.dataset.category === activeFilter || item.dataset.family === activeFilter;
        const matchesSearch = !query || normalize(item.dataset.search).includes(query);
        const shouldShow = matchesFilter && matchesSearch;

        item.hidden = !shouldShow;
        if (!shouldShow) item.removeAttribute('open');
        if (shouldShow) visibleCount += 1;
      });

      if (emptyState) emptyState.hidden = visibleCount !== 0;
    };

    if (searchInput) {
      searchInput.addEventListener('input', updateResults);
    }

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.skyHelpFilter || 'all';
        filterButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        updateResults();
      });
    });

    updateResults();
  });
})();
